import { useState } from 'react';
import './departments.css';

export default function Departments() {
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    
    const departmentsList = [
        { id: 1, name: 'دپارتمان ریمو', videoCount: 3, media: null },
        { id: 2, name: 'دپارتمان آرایش دائم', videoCount: 6, media: null },
        { id: 3, name: 'دپارتمان رنگ و لایت', videoCount: 8, media: '1.jpeg' },
        { id: 4, name: 'دپارتمان میکاپ', videoCount: 0, media: null },
        { id: 5, name: 'دپارتمان پوست', videoCount: 3, media: null },
        { id: 6, name: 'دپارتمان هیرکات', videoCount: 1, media: '1.jpeg' },
        { id: 7, name: 'دپارتمان کراتین', videoCount: 2, media: null },
        { id: 8, name: 'دپارتمان شینیون', videoCount: 0, media: null },
        { id: 9, name: 'دپارتمان اسکالپ و اسکراپ', videoCount: 0, media: null },
        { id: 10, name: 'دپارتمان بافت مو', videoCount: 0, media: null },
        { id: 11, name: 'دپارتمان براشینگ و هیر استایلر', videoCount: 0, media: null },
        { id: 12, name: 'دپارتمان ناخن', videoCount: 0, media: null },
        { id: 13, name: 'دپارتمان کوچینگ', videoCount: 6, media: null },
        { id: 14, name: 'دپارتمان عکاسی و فیلمبرداری', videoCount: 0, media: null },
        { id: 15, name: 'دپارتمان مد و استایل', videoCount: 0, media: null },
        { id: 17, name: 'دپارتمان زبان', videoCount: 0, media: null },
        { id: 18, name: 'دپارتمان مژه', videoCount: 0, media: null },
        { id: 19, name: 'دپارتمان گریم سینمایی', videoCount: 0, media: null },
        { id: 20, name: 'دپارتمان بازیگری', videoCount: 0, media: null },
        { id: 21, name: 'دپارتمان موسیقی', videoCount: 0, media: null },
        { id: 22, name: 'دپارتمان هوش مصنوعی', videoCount: 0, media: null },
        { id: 23, name: 'دپارتمان دیجیتال مارکتینگ', videoCount: 0, media: null },
        { id: 24, name: 'دپارتمان گردشگری', videoCount: 0, media: null },
        { id: 25, name: 'دپارتمان ماساژ و اسپا', videoCount: 0, media: null },
        { id: 26, name: 'دپارتمان ایمنی و بهداشت محیط', videoCount: 0, media: null },
        { id: 27, name: 'دپارتمان بازاریابی و فروش', videoCount: 0, media: null },
        { id: 28, name: 'دپارتمان صادرات', videoCount: 0, media: null },
        { id: 29, name: 'دپارتمان اینکامینگ', videoCount: 0, media: null },
        { id: 30, name: 'دپارتمان بازسازی ، دکوراسیون و تجهیز سالنها ، آموزشگاهها و کلینیک های پوست و مو', videoCount: 0, media: null },
    ];

    const selectedDept = departmentsList.find(dept => dept.id === selectedDepartment);

    const isImage = (media) => {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
        return media && imageExtensions.some(extension => media.endsWith(extension));
    };

    return (
        <div className="departmentspage">
            {selectedDepartment === null ? (
                <div className='departmentslist'>
                    <ul>
                        {departmentsList.map((department) => (
                            <li key={department.id} onClick={() => setSelectedDepartment(department.id)}>
                                {department.name}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                <div className='storymotion'>
                    <div className='backbutton' onClick={() => setSelectedDepartment(null)}>بازگشت به لیست دپارتمان ها</div>
                    {selectedDept && isImage(selectedDept.media) && (
                        <img src={`http://dl.mahoganyacademy.de/departments/${selectedDepartment}/${selectedDept.media}`} alt={selectedDept.name} className="department-image" />
                    )}
                    {selectedDept && Array.from({ length: selectedDept.videoCount }, (_, index) => (
                        <video
                            key={index}
                            src={`http://dl.mahoganyacademy.de/departments/${selectedDepartment}/${index + 1}.mp4`}
                            controls>
                        </video>
                    ))}
                </div>
            )}
        </div>
    );
}
